module.exports = __webpack_public_path__ + "img/CreditTech.46979cda.svg";